import { useState, useEffect } from 'react'

import Api from 'services/api'
import { DeviceMaintenanceTrends } from 'types/DeviceMetric'

const useDeviceMaintenanceTrends = (deviceId: string) => {
  const [maintenanceTrends, setMaintenanceTrends] = useState<DeviceMaintenanceTrends | null>(null)
  const [areMaintenanceTrendsLoaded, setAreMaintenanceTrendsLoaded] = useState<boolean>(false)

  useEffect(() => {
    setAreMaintenanceTrendsLoaded(false)

    Api.DeviceMetrics.getDeviceMaintenanceTrends(deviceId)
      .then((res) => {
        setMaintenanceTrends(res)
        setAreMaintenanceTrendsLoaded(true)
      })
      .catch(() => {
        setMaintenanceTrends(null)
        setAreMaintenanceTrendsLoaded(true)
      })
  }, [deviceId])

  return { maintenanceTrends, areMaintenanceTrendsLoaded }
}

export default useDeviceMaintenanceTrends
